export enum VendedorActions {
    VendedoresList = "VendedoresList",
    CreateVendedorForm = "CreateVendedorForm",
    VendedorDetails = "VendedorDetails",
}

export enum UserActions {
    UserList = "UserList",
    UserCreateForm = "UserCreateForm",
    UserDetails = "UserDetails",
}

